import { removeUserDataCookie } from '../utils/CookieUtils';

const logOutFunction = () => {
  localStorage.removeItem('isUserSeeingTutorialFirstTime');
  removeUserDataCookie();
  window.location.href = '/'; // for remove data in redux state
};

export default logOutFunction;
